import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-not-found',
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.css']
})
export class NotFoundComponent implements OnInit {

  pathName

  constructor(private router: Router) { }

  ngOnInit(): void {
    this.pathName = this.formatPath(this.router.url)
  }

  formatPath(value: string) {
      let stringArray = value.split('/').filter(data => data !== 'null')
      return stringArray.join('')
    
  }

}
